<template>
  <v-layout class="fill-height">
    <v-row v-if="assignmentAllowed" class="fill-height ma-0">
      <v-col cols="12" md="12" class="pa-2">
        <v-card :style="{ backgroundColor: backgroundColor }">
          <v-tabs 
            v-model="activeTab" 
            @update:modelValue="resetSelectedTeam"
            show-arrows="false"
            touch="false"
            >
            <v-tab value="overview">{{ $t('overview') }}</v-tab>
            <v-tab value="assignment">{{ $t('assignment') }}</v-tab>
          </v-tabs>

          <v-card-text>
            <v-window v-model="activeTab" disabled>
              <v-window-item value="overview">
                <v-sheet :style="{ backgroundColor: backgroundColor }" class="pa-2">
                  <TeamsPageOverview v-if="activeTab === 'overview'" />
                </v-sheet>
              </v-window-item>

              <v-window-item value="assignment"> 
                <TeamsPageAssignment 
                   v-if="activeTab === 'assignment'"
                  :assignableTeamIds="assignableTeamIds"
                />
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="12" class="pa-2">
        <TeamsPageOverview />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useTheme } from 'vuetify';
import TeamsPageOverview from './TeamsPageOverview.vue';
import TeamsPageAssignment from './TeamsPageAssignment.vue';

const store = useStore();
const theme = useTheme();

const permissionRulesObj = computed(() => store.getters.getPermissionRulesObj);
const backgroundColor = computed(() => {
  return theme.global.name.value === 'dark' ? '#192b35' : '#eeeeee';
 });

const activeTab = ref('overview');

const assignableTeamIds = computed(() => {
  const result = {};

  Object.entries(permissionRulesObj.value).forEach(([teamId, rules]) => {
    const hasIssueAssign = rules.some(rule => 
      rule.action === 'issueAssign' && 
      rule.permissionOptions.length === 0 && 
      rule.permissionConditions.length === 0
    );

    const hasFormAssign = rules.some(rule => 
      rule.action === 'formAssign' && 
      rule.permissionOptions.length === 0 && 
      rule.permissionConditions.length === 0
    );

    result[teamId] = hasIssueAssign && hasFormAssign;
  });

  return result;
});



const assignmentAllowed = computed(() => {
  return Object.values(assignableTeamIds.value).some(value => value === true);
});

onMounted(async () => {
  await store.commit('resetFilters');
});


</script>
